const LOGIN = '/account/token/'
const REGISTRATION = '/account/register/'
const ACCOUNT_ME = '/account/users/me/'
const TRIP_ENDPOINT = '/trips/'
const START_TRIP = `${TRIP_ENDPOINT}`
const registerPassengersEndpoint = (id) => `${TRIP_ENDPOINT + id}/register-passengers/`

export {
  LOGIN,
  REGISTRATION,
  TRIP_ENDPOINT,
  START_TRIP,
  registerPassengersEndpoint,
  ACCOUNT_ME
}



// WEBPACK FOOTER //
// ./src/services/urls.js